import { BaseModel } from '../common/base-model/base-model';

export class ServiceGroupServices extends BaseModel {
  constructor(
    public override id?: string,
    public service_group_id?: string,
    public service_id?: string,
    public deleted?: boolean,
  ) {
    super();
  }

  toJSON() {
    return {
      id: this.id,
      service_group_id: this.service_group_id,
      service_id: this.service_id,
      deleted: !!this.deleted,
    };
  }

  static fromJson(jsonData: any): ServiceGroupServices {
    return Object.assign(new ServiceGroupServices(), jsonData);
  }
}
